import { IsUUID } from 'class-validator';
import { BaseCreateDto } from '../base.dto';
import type { BaseDto } from '../base.dto';
import type { GenderDto } from '../clinical-details';

export interface TrainingPatientDto extends BaseDto {
  gender: GenderDto;
}

export class CreateTrainingPatientDto extends BaseCreateDto {
  @IsUUID()
  genderId: string;
}
